// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  background-color: white;
  padding: 32px 48px;
  overflow-y: scroll;
  display: grid;
  grid-template-rows: min-content 1fr;
}

.dashboard-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.dashboard-right {
  display: grid;
  grid-template-rows: repeat(2, min-content);
  gap: 28px;
}

.leaderboard {
  max-height: 292px;
  overflow-y: auto;
}

.previous-games {
  display: grid;
  align-items: end;
}

@media (max-width: 980px) {
  .dashboard-container {
    padding: 24px;
  }
}

@media (max-width: 768px) {
  .dashboard-content {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/dashboard.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dashboard-container {\n  background-color: white;\n  padding: 32px 48px;\n  overflow-y: scroll;\n  display: grid;\n  grid-template-rows: min-content 1fr;\n}\n\n.dashboard-content {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.dashboard-right {\n  display: grid;\n  grid-template-rows: repeat(2, min-content);\n  gap: 28px;\n}\n\n.leaderboard {\n  max-height: 292px;\n  overflow-y: auto;\n}\n\n.previous-games {\n  display: grid;\n  align-items: end;\n}\n\n@media (max-width: 980px) {\n  .dashboard-container {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-content {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
